import React, { useEffect, useState } from 'react';

import { useFirestoreDemmi } from '@core/contexts/FirestoreDemmiContext';
import DemmiCard from '@demmi-ui/Card/Card';
import DemmiSelect from '@demmi-ui/Select/Select';
import { CategoriesHelper } from '@helpers/categories.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

interface Props {
  categoryID?: string;
  setCategoryID: React.Dispatch<React.SetStateAction<string | undefined>>;
}

const ProductCategory: React.FC<Props> = ({ categoryID, setCategoryID }) => {
  const CSSBlock = 'product-category';
  const firestoreDemmi = useFirestoreDemmi();
  const [primaryCategory, setPrimaryCategory] =
    useState<DemmiFS.CategoryParent>();
  const [secondaryCategory, setSecondaryCategory] =
    useState<DemmiFS.Category>();
  const [categories, setCategories] = useState<DemmiFS.CategoryParent[]>();

  useEffect(() => {
    if (firestoreDemmi) {
      const cat = firestoreDemmi.categories.find(c => {
        // if selected category is "Other" within parent category
        if (c.id === categoryID) {
          setSecondaryCategory(
            DemmiFS.CategoriesHelper.getCategoryOther(c.name),
          );
          return true;
        }

        // if selected child category is specified
        return c.children.find((x: DemmiFS.Category) => {
          if (x.id === categoryID) {
            setSecondaryCategory(x);
            return true;
          }
        });
      });
      setPrimaryCategory(cat);
      setCategories(firestoreDemmi.categories);
    }
  }, [firestoreDemmi, categoryID]);

  const parentContent = CategoriesHelper.getMenuContent<DemmiFS.CategoryParent>(
    categories ?? [],
  );
  const childContent = CategoriesHelper.getMenuContent<DemmiFS.Category>(
    primaryCategory?.children ?? [],
    [DemmiFS.CategoriesHelper.getCategoryOther(primaryCategory?.name ?? '')],
  );

  return (
    <DemmiCard title="Category" className={CSSBlock}>
      <div className={`${CSSBlock}__list`}>
        <DemmiSelect
          content={parentContent}
          value={primaryCategory?.id ?? ''}
          visibleValue={primaryCategory?.name ?? ''}
          valueIcon={primaryCategory?.icon}
          onChange={cat => {
            setPrimaryCategory(categories?.find(c => c.id === cat));
          }}
        />
        <DemmiSelect
          content={childContent}
          value={secondaryCategory?.id ?? ''}
          visibleValue={secondaryCategory?.name ?? ''}
          valueIcon={secondaryCategory?.icon}
          onChange={catID => {
            const cat = primaryCategory?.children?.find(c => c.id === catID);
            setSecondaryCategory(cat);
            catID === DemmiFS.CategoriesHelper.CATEGORY_ID_OTHER
              ? setCategoryID(primaryCategory!.id)
              : setCategoryID(catID);
          }}
        />
      </div>
    </DemmiCard>
  );
};

export default ProductCategory;
